import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fromDate: "",
  toDate: "",
  action: "generate",
  selectedMonth: "January",
  chartData: null,
  viewGeneralReport: false,
  weeklyConversionsData: {
    labels: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ],
    datasets: [
      {
        label: "Leads Conversions",
        backgroundColor: [
          "#34a1eb",
          "#eb34d2",
          "#6366f1",
          "#a78bfa",
          "#ec4899",
          "#facc15",
          "#3b82f6",
        ],
        data: [50, 70, 100, 80, 120, 60, 90],
      },
    ],
  },
  sourcesConversionData: {
    labels: ["Abroad Counseling", "Career Counseling", "Test Prep", "Visa"],
    datasets: [
      {
        label: "Sources Conversion",
        backgroundColor: "#86efac",
        data: [700, 100, 80, 50],
      },
    ],
  },
  freshToEnquiryData: {
    labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
    datasets: [
      {
        label: "Fresh Lead to Enquiry Lead",
        backgroundColor: "#ff7b8f",
        data: [80, 120, 100, 160],
      },
    ],
  },
  enquiryToCustomerData: {
    labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
    datasets: [
      {
        label: "Enquiry Lead to Customer",
        backgroundColor: "#7ee787",
        data: [50, 80, 60, 110],
      },
    ],
  },
  monthlyData: {
    labels: ["1-1-2025", "2-1-2025", "3-1-2025", "4-1-2025", "5-1-2025"],
    datasets: [
      {
        label: "Monthly Data",
        backgroundColor: "#60a5fa",
        data: [300, 400, 500, 600, 700],
      },
    ],
  },
};

const leadReportSlice = createSlice({
  name: "leadReport",
  initialState,
  reducers: {
    setFromDate: (state, action) => {
      state.fromDate = action.payload;
    },
    setToDate: (state, action) => {
      state.toDate = action.payload;
    },
    setAction: (state, action) => {
      state.action = action.payload;
    },
    setSelectedMonth: (state, action) => {
      state.selectedMonth = action.payload;
    },
    setChartData: (state, action) => {
      state.chartData = action.payload;
    },
    toggleViewGeneralReport: (state) => {
      state.viewGeneralReport = !state.viewGeneralReport;
    },
    setWeeklyConversionsData: (state, action) => {
      state.weeklyConversionsData = action.payload;
    },
    setSourcesConversionData: (state, action) => {
      state.sourcesConversionData = action.payload;
    },
    setFreshToEnquiryData: (state, action) => {
      state.freshToEnquiryData = action.payload;
    },
    setEnquiryToCustomerData: (state, action) => {
      state.enquiryToCustomerData = action.payload;
    },
    setMonthlyData: (state, action) => {
      state.monthlyData = action.payload;
    },
  },
});

export const {
  setFromDate,
  setToDate,
  setAction,
  setSelectedMonth,
  setChartData,
  toggleViewGeneralReport,
  setWeeklyConversionsData,
  setSourcesConversionData,
  setFreshToEnquiryData,
  setEnquiryToCustomerData,
  setMonthlyData,
} = leadReportSlice.actions;

export default leadReportSlice.reducer;
